import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export type PaymentMethodChoice = 'card' | 'ach';

@Component({
  selector: 'app-payment-method-chooser-dialog',
  templateUrl: './payment-method-chooser-dialog.component.html',
  styleUrls: ['./payment-method-chooser-dialog.component.scss'],
  standalone: false,
})
export class PaymentMethodChooserDialogComponent {
  constructor(public dialogRef: MatDialogRef<PaymentMethodChooserDialogComponent, PaymentMethodChoice | undefined>) {}

  choose(method: PaymentMethodChoice): void {
    this.dialogRef.close(method);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
